import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
import TapForSoundStore from './tap-for-sound-store';

export default class TapForSoundLayer extends Reflux.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.store = new TapForSoundStore(props);
    }
    initEvents() {
        $(this.refs[`tap-${this.props.config}`]).on('click.TapForSound', (e) => {
            this.props.onSetMuted(false);
        });
        /*
        $(document).on('scroll.TapForSound', (e) => {
            this.props.onSetMuted(false);
        });
        */
    }
    shouldComponentUpdate(nextProps, nextState) {
        return nextState.isVisible != this.state.isVisible || (this.props.mediaApi==null && nextProps.mediaApi!=null);
    }
    componentDidMount() {
      this.initEvents();
    }
    componentDidUpdate(prevProps,prevState){
      if(this.state.isVisible==false){
        $(document).off('click.TapForSound');
        //$(document).off('scroll.TapForSound');
      }
    }
    doClick(e){
        this.setState({isVisible: false});
        e.preventDefault();
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        this.props.onSetMuted(false);
    }

    render() {
        if (this.state.isVisible == false) {
            return null;
        }
        return (
            <div onClick={this.doClick.bind(this)} ref={`tap-${this.props.config}`} className='tap-for-sound-layer'>
                <div className='tap-for-sound-button'  role="button">
                    <span className="video-player-volume-muted-button" />
                    <span className="label"> Tap for Sound </span>
                </div>
            </div>
        )
    }
}

TapForSoundLayer.propTypes = {
    'config': PropTypes.string,
    'onSetMuted': PropTypes.func

}

TapForSoundLayer.defaultProps = {
    'config': '',
    'onSetMuted': ()=>{}
}



// WEBPACK FOOTER //
// ./medscape_modules/video/tap-for-sound/tap-for-sound-layer.jsx